/**
 * Loại quyết định kèm theo nhập kho
 */
export default {
  // Quyết định
  Decision: 0,
  // Biên bản bàn giao vật chứng
  EvidenceMinutes: 1
};
